import type { ToastItem } from '@globalmed/atlas-ui';
import { create } from 'zustand';
import { IToastStore } from './types';

export const useToastStore = create<IToastStore>((set) => ({
  toasts: [],
  setToast: (body) =>
    set(({ toasts }) => {
      const toastId = String(Date.now());
      const toast: ToastItem = {
        id: toastId,
        body,
        timeout: setTimeout(() => {
          set(({ toasts }) => {
            return {
              toasts: toasts.map((t) =>
                t?.id !== toastId ? t : { ...t, body: null },
              ),
            };
          });
          setTimeout(() => {
            set(({ toasts }) => {
              return {
                toasts: toasts.filter((t) => t?.id !== toastId),
              };
            });
          }, 500);
        }, 5000),
      };
      return {
        toasts: [...toasts, toast],
      };
    }),
  clearToasts: () =>
    set(({ toasts }) => {
      setTimeout(() => {
        set(() => ({ toasts: [] }));
      }, 500);
      return {
        toasts: toasts.map((t) => ({ ...t, body: null })),
      };
    }),
}));
